import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { ConnectedRouter } from 'connected-react-router'

import { ROUTING } from './constants'
import history from './history'
import VehicleTestResult, {
  EphemeralVehicleTestResult,
} from './components/VehicleTestResult/VehicleTestResult'
import NavigationRedirect from './containers/NavigationRedirect'
import DemoPayloadPage from './components/DemoPayloadPage'
import Forbidden from './components/Forbidden'
import Login from './components/Login'
import Logout from './components/Logout'
import Auth0Callback from './components/Auth0Callback'
import MainMenuContainer from './containers/MainMenuContainer'
import VehicleTestsSearchContainer from './containers/VehicleTestsSearchContainer'
import UserAddContainer from './containers/UserAddContainer'
import UserEditContainer from './containers/UserEditContainer'
import DtcMemoSearchContainer from './containers/DtcMemoSearchContainer'
import DTCMemoContainer from './containers/DTCMemoContainer'
import ProductionLinePage from './ProductionLineDashboard'
import AssociateIssuePage from './ProductionLineDashboard/AssociateIssuePage'
import RepairNotePage from './ProductionLineDashboard/RepairNotePage'
import DTCMemoAndMappingEdit from './components/DTCMapping/DTCMemoAndMappingEdit'
import QrCodeScanContainer from './containers/QrCodeScanContainer'
import GettingStartedContainer from './containers/GettingStartedContainer'
import ReportSubMenu from './Reports'
import { UsageMonitor } from './Reports/UsageMonitor'
import LoggedUsersMonitorPage from './Reports/LoggedUsersMonitorPage'
import GlobalSearchUsagePage from './Reports/GlobalSearchUsagePage'
import IncidentTabs from './IncidentMgmt/IncidentTabs'
import AddNewIssue from './IncidentMgmt/AddNewIssue'
import {
  JohnDeereAlertsPage,
  JohnDeereAuthorize,
} from './integrations/JohnDeere'
import BuildYourTestPage from './components/BuildYourTest'
import GlobalSearchPage, {
  GlobalSearchProvider,
  VisualAidPage,
} from './GlobalSearch'
import VehicleConfigurationSearch from './components/VehicleConfiguration/VehicleConfigurationSearch'
import { VINSearchInputProvider } from './components/VINSearchInput/VINSearchInputContext'
import { VirtualVehicleConfigurationProvider } from './VirtualVehicleConfiguration/VirtualVehicleConfigurationContext'
import ReportMonitorContainer from './Reports/ReportMonitorContainer'
import ReportContainer from './Reports/ReportContainer'
import UserListContainer from './containers/UserListContainer'

const Routing = () => (
  <ConnectedRouter history={history}>
    <Switch>
      <Route exact path="/tracer/:pathId">
        <VehicleTestResult />
      </Route>
      <Route exact path="/vehicle-test/preview">
        <EphemeralVehicleTestResult />
      </Route>
      <Route
        exact
        path="/navigation/vehicle_test_result/:vehicleTestResultId/:navType"
      >
        <NavigationRedirect />
      </Route>
      <Route exact path="/auth0callback" component={Auth0Callback} />
      <Route exact path="/login" component={Login} />
      <Route exact path="/logout" component={Logout} />
      <Route exact path="/forbidden" component={Forbidden} />
      <Route exact path="/" component={MainMenuContainer} />
      <Route exact path="/demo" component={DemoPayloadPage} />
      <Route
        exact
        path="/search/:vin?"
        component={VehicleTestsSearchContainer}
      />
      <Route exact path="/users/add" component={UserAddContainer} />
      <Route exact path="/users/:userId" component={UserEditContainer} />
      <Route exact path="/users" component={UserListContainer} />
      <Route exact path="/global-search/configuration">
        <VirtualVehicleConfigurationProvider>
          <VINSearchInputProvider>
            <VehicleConfigurationSearch path={'global-search'} />
          </VINSearchInputProvider>
        </VirtualVehicleConfigurationProvider>
      </Route>
      <Route path="/global-search/vin">
        <GlobalSearchProvider>
          <Route
            exact
            path="/global-search/vin/:vin"
            render={() => <GlobalSearchPage />}
          />
          <Route
            exact
            path="/global-search/vin/:vin/visual-aid"
            render={() => <VisualAidPage />}
          />
        </GlobalSearchProvider>
      </Route>
      <Route
        exact
        path={ROUTING.memoAuthoring}
        component={DtcMemoSearchContainer}
      />
      <Route
        exact
        path="/dtc-memo/:dtcMemoId/:add?"
        component={DTCMemoContainer}
      />
      <Route
        exact
        path="/dtc-mapping/:dtcMemoId/:vin"
        component={DTCMemoAndMappingEdit}
      />
      <Route
        exact
        path="/production-line-dashboard/repair-note/:sourceType/:sourceId"
        component={RepairNotePage}
      />
      <Route
        exact
        path="/production-line-dashboard/associate/:vehicleTestId"
        component={AssociateIssuePage}
      />
      <Route
        exact
        path="/production-line-dashboard"
        component={ProductionLinePage}
      />
      <Route exact path="/qrcode-scan" component={QrCodeScanContainer} />
      <Route
        exact
        path="/getting-started"
        component={GettingStartedContainer}
      />

      <Route exact path="/reports" component={ReportSubMenu} />
      <Route exact path="/reports/fault-reports" component={ReportContainer} />
      <Route exact path="/reports/usage-monitor" component={UsageMonitor} />
      <Route
        exact
        path="/reports/logged-users"
        component={LoggedUsersMonitorPage}
      />
      <Route
        exact
        path="/reports/global-search-usage"
        component={GlobalSearchUsagePage}
      />

      <Route exact path="/incidents" component={IncidentTabs} />
      <Route
        exact
        path="/incidents/associate/:problemLogId"
        component={AssociateIssuePage}
      />
      <Route
        exact
        path="/incidents/associate/:problemLogId/new-issue"
        component={AddNewIssue}
      />
      <Route exact path="/build-your-test" component={BuildYourTestPage} />
      {/* Start of John Deere routes */}
      <Route exact path="/alerts" component={JohnDeereAlertsPage} />
      <Route exact path="/jd/authorize" component={JohnDeereAuthorize} />
      {/* END of John Deere routes */}
      <Redirect exact strict to="/" push={false} />
    </Switch>
  </ConnectedRouter>
)

export default Routing
